// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 7235) return "static/chunks/7235.0793728313a80c75.js";
	// return url for filenames based on template
	return "static/chunks/" + chunkId + "-" + {"1644":"1e29d3926ab50e61","2688":"e05a0b37fe27741f","4143":"038e4e31ffe45cdd","5146":"f9c6931bb9ff853b","8911":"35a0283edf5fa6c5","9070":"3c4ab9e2f9674b79","9382":"2ca8fa8f8018d7fa"}[chunkId] + ".js";
};